import React, { FC } from "react"
import { HeroProps } from "./Hero.types"

const HeroUnderline: FC<HeroProps> = ({
    children,
    className,
    ...htmlProps
}: HeroProps) => {
    const klass = `zb-hero-underline ${className || ""}`
    return (
        <span className={klass} {...htmlProps}>
            {children}
        </span>
    )
}

export default HeroUnderline
